// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nu-1";
export var messageSideRight = "_nu-2";
export var subscribeToBackInStockBubbleContainer = "_nu-0";